import { UserInfo } from './user-info';

export class Member {
  constructor(
    public user: UserInfo,
    public groupRole: string,
    public joinedAt: string,
  ) {}
}
